import { playMailNotificationSound } from "@/lib/mail/mailNotificationSound";

/**
 * Son différé jusqu’à ce que le(s) mail(s) soient vraiment visibles
 * (fin de préparation / pending reveal), pour coller pastille / son / ligne.
 */
const PREPARE_GRACE_MS = 2_500;

let pendingPlays = 0;
let preparing = false;
let pendingReveal = false;
let graceTimer: number | null = null;

function blocked(): boolean {
  return preparing || pendingReveal;
}

function clearGraceTimer(): void {
  if (graceTimer != null) {
    window.clearTimeout(graceTimer);
    graceTimer = null;
  }
}

function scheduleGraceFlush(): void {
  if (graceTimer != null) return;
  graceTimer = window.setTimeout(() => {
    graceTimer = null;
    if (blocked()) return;
    flushPendingMailNotificationSound();
  }, PREPARE_GRACE_MS);
}

export function noteIncomingPrepareActive(active: boolean): void {
  const wasBlocked = blocked();
  preparing = active;
  if (blocked()) {
    clearGraceTimer();
    return;
  }
  // Grâce : laisse le gate liste / preparing se coller avant le son.
  if (wasBlocked && !blocked() && pendingPlays > 0) {
    scheduleGraceFlush();
  }
}

/** True tant que des arrivées attendent corps/PJ client (tous comptes). */
export function notePendingRevealActive(active: boolean): void {
  const wasBlocked = blocked();
  pendingReveal = active;
  if (blocked()) {
    clearGraceTimer();
    return;
  }
  if (wasBlocked && !blocked() && pendingPlays > 0) {
    scheduleGraceFlush();
  }
}

export function requestMailNotificationSound(): void {
  pendingPlays += 1;
  if (blocked()) {
    clearGraceTimer();
    return;
  }
  scheduleGraceFlush();
}

export function flushPendingMailNotificationSound(): void {
  if (pendingPlays <= 0) return;
  pendingPlays = 0;
  playMailNotificationSound();
}
